import { LegacyStack, TextField, Checkbox, Text } from "@shopify/polaris";
import { CollectionPicker } from './CollectionPicker.jsx';

export function CollectionFlatRateConfiguration ({ form, handleChange, errors }) {
    return (
        <LegacyStack vertical>
            <LegacyStack.Item>
                {errors['configuration.collection.id'] && (
                    <div>
                        <Text  variant="bodyMd" as="span" tone="critical">{errors['configuration.collection.id']}</Text>
                    </div>
                )}
                <CollectionPicker field="collection"
                                  label="Collection"
                                  form={form}
                                  errors={errors}
                                  handleChange={handleChange}
                                  askQuantity={false} />

                <Checkbox checked={form.automatic}
                          label="Applies automatically without Code"
                          id="automatic"
                          onChange={handleChange}
                          error={errors.automatic} />
            </LegacyStack.Item>
            <LegacyStack>
                <TextField type="number"
                           min="0"
                           step="1"
                           label="Min. quantity"
                           id={`configuration.min_quantity`}
                           onChange={handleChange}
                           error={errors[`configuration.min_quantity`]}
                           value={form.configuration.min_quantity} />
                <TextField type="number"
                           suffix="$"
                           min="0"
                           label="Price"
                           id={`configuration.price`}
                           onChange={handleChange}
                           error={errors[`configuration.price`]}
                           value={form.configuration.price} />
            </LegacyStack>
        </LegacyStack>
    );
}
